export enum EVENT_COURSE_TYPE_ENUM {
  'IN_PERSON' = 'IN_PERSON',
  'ONLINE' = 'ONLINE',
}
export const EVENT_COURSE_TYPE_ENUM_VALUES = Object.values(EVENT_COURSE_TYPE_ENUM);
